import { db } from "services/firebase";

function mapTciDoc(doc) {
  const data = doc.data() || {};
  return {
    id: doc.id,
    ...data,
    scope: data.scope || "global",
    institutionId: data.institutionId ?? null,
  };
}

function sortTciRows(rows) {
  return [...rows].sort((a, b) => (a.name || a.id).localeCompare(b.name || b.id));
}

export function groupTciRegistryRows(rows = []) {
  const platform = [];
  const institutional = [];
  rows.forEach((row) => {
    if (row.scope === "institutional") institutional.push(row);
    else platform.push(row);
  });
  return { platform, institutional };
}

/**
 * Global platform TCIs plus institutional TCIs scoped to the caller's institution.
 */
export async function listTciRegistry({ institutionId } = {}) {
  const globalSnap = await db.collection("tciRegistry").where("scope", "==", "global").get();
  const globalRows = globalSnap.docs
    .map(mapTciDoc)
    .filter((row) => row.isActive !== false);

  let institutionalRows = [];
  const instId = (institutionId || "").trim();
  if (instId) {
    const instSnap = await db
      .collection("tciRegistry")
      .where("scope", "==", "institutional")
      .where("institutionId", "==", instId)
      .get();
    institutionalRows = instSnap.docs.map(mapTciDoc).filter((row) => row.isActive !== false);
  }

  return sortTciRows([...globalRows, ...institutionalRows]);
}

export async function listClinicalDomains({ institutionId }) {
  if (!institutionId) return [];
  const snap = await db
    .collection("clinicalDomains")
    .where("institutionId", "==", institutionId)
    .where("isActive", "==", true)
    .get();
  return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export async function listAllClinicalDomains({ institutionId }) {
  if (!institutionId) return [];
  const snap = await db
    .collection("clinicalDomains")
    .where("institutionId", "==", institutionId)
    .get();
  return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export async function listFdeAssignments({ institutionId }) {
  if (!institutionId) return [];
  const snap = await db
    .collection("fdeAssignments")
    .where("institutionId", "==", institutionId)
    .get();
  return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export async function listActiveFdeAssignmentsForUser({ uid, institutionId }) {
  if (!uid) return [];
  let query = db.collection("fdeAssignments").where("uid", "==", uid);
  if (institutionId) {
    query = query.where("institutionId", "==", institutionId);
  }
  const snap = await query.get();
  return snap.docs
    .map((doc) => ({ id: doc.id, ...doc.data() }))
    .filter((row) => row.status === "active" || row.status === "pending-training");
}

export const FDE_ROLE_LABELS = {
  "fde-t": "Technical Readiness Lead",
  "fde-c": "Clinical Annotator",
  "fde-dc": "TCI Manager",
  "global-tci-manager": "Global TCI Manager",
};

export const FDE_STATUS_LABELS = {
  active: "Active",
  suspended: "Suspended",
  "pending-training": "Pending training",
};

export const TCI_PHASE_OPTIONS = [
  "Triage",
  "Assessment",
  "Treatment",
  "Disposition",
  "Discharge",
  "Pre-Visit",
  "Check-In",
  "Visit",
  "Follow-Up",
];

export const TCI_PRODUCT_OPTIONS = [
  "CareStart",
  "ChartMind",
  "FusionMSI",
  "CMR",
];
